module.exports = __webpack_public_path__ + "img/scannerapp.214778ae.png";